// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__2VW3Y","log":"ModalInventoryLogs_log__1h22Q","date":"ModalInventoryLogs_date__119PB","userName":"ModalInventoryLogs_userName__xcLks"};